import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type UpdateAuditCommentsReviewProps = {
  encounterId: string;
  chartCode: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useUpdateAuditCommentsReview({
  encounterId,
  chartCode,
  sectionCode,
  subsectionCode,
}: UpdateAuditCommentsReviewProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "UpdateAuditCommentsSubsectionReview",
      { encounterId, chartCode, sectionCode, subsectionCode },
    ],
    () =>
      axiosChartInstance.post(
        subsectionCode
          ? `/v1/audits/subsection/review/${encounterId}/${chartCode}/${sectionCode}/${subsectionCode}`
          : `/v1/audits/section/review/${encounterId}/${chartCode}/${sectionCode}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsSectionIndicator",
          { encounterId, chartCode, sectionCode, validateSubsections: true },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsSectionIndicator",
          { encounterId, chartCode, sectionCode, validateSubsections: false },
        ]);
        if (subsectionCode) {
          queryClient.invalidateQueries([
            "AuditCommentsSubsectionIndicator",
            { encounterId, chartCode, sectionCode, subsectionCode },
          ]);
        }
      },
    }
  );
}

type UpdateAuditCommentsSharedReviewProps = {
  encounterId: string;
  sectionCode: string;
  subsectionCode?: string;
};

function useUpdateAuditCommentsSharedReview({
  encounterId,
  sectionCode,
  subsectionCode,
}: UpdateAuditCommentsSharedReviewProps) {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    [
      "UpdateAuditCommentsSharedSubsectionReview",
      { encounterId, sectionCode, subsectionCode },
    ],
    () =>
      axiosChartInstance.post(
        subsectionCode
          ? `/v1/audits/subsection/review/${encounterId}/shared/${sectionCode}/${subsectionCode}`
          : `/v1/audits/section/review/${encounterId}/shared/${sectionCode}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "AuditCommentsSharedSectionIndicator",
          { encounterId, sectionCode, validateSubsections: true },
        ]);
        queryClient.invalidateQueries([
          "AuditCommentsSharedSectionIndicator",
          { encounterId, sectionCode, validateSubsections: false },
        ]);
        if (subsectionCode) {
          queryClient.invalidateQueries([
            "AuditCommentsSharedSubsectionIndicator",
            { encounterId, sectionCode, subsectionCode },
          ]);
        }
      },
    }
  );
}

export { useUpdateAuditCommentsReview, useUpdateAuditCommentsSharedReview };
